"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var sidebar_style_component_1 = require("./sidebar.style.component");
var link_element_compontent_1 = __importDefault(require("./link-element.compontent"));
var Logo_1 = __importDefault(require("../icons/generated/Logo"));
var LogoWithText_1 = __importDefault(require("../icons/generated/LogoWithText"));
var SidebarWidth;
(function (SidebarWidth) {
    SidebarWidth["closed"] = "64px";
    SidebarWidth["open"] = "240px";
})(SidebarWidth = exports.SidebarWidth || (exports.SidebarWidth = {}));
var Sidebar = function (_a) {
    var home = _a.home, isOpen = _a.isOpen, profile = _a.profile, list = _a.list, onToggle = _a.onToggle;
    var width = isOpen ? SidebarWidth.open : SidebarWidth.closed;
    return (react_1.default.createElement(sidebar_style_component_1.SidebarWrapper, { width: width },
        react_1.default.createElement(sidebar_style_component_1.LogoWrapper, null,
            react_1.default.createElement(sidebar_style_component_1.LogoLink, { exact: true, to: home }, isOpen ? react_1.default.createElement(Logo_1.default, null) : react_1.default.createElement(LogoWithText_1.default, null))),
        react_1.default.createElement(sidebar_style_component_1.Toggle, { onClick: onToggle }, isOpen ? react_1.default.createElement(sidebar_style_component_1.ToggleIconLeft, null) : react_1.default.createElement(sidebar_style_component_1.ToggleIconRight, null)),
        list.map(function (element, index) { return (react_1.default.createElement(link_element_compontent_1.default, { key: index, link: element, showLabel: isOpen })); }),
        profile && react_1.default.createElement(link_element_compontent_1.default, { link: profile, showLabel: isOpen })));
};
Sidebar.displayName = 'Sidebar';
exports.default = Sidebar;
